/* MaxxAlive homepage (2026 redesign). Loaded once, even though every section references it. */
(function () {
  if (window.__maHomeLoaded) return;
  window.__maHomeLoaded = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(html, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ma-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.classList.toggle('is-error', !!isError);
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3200);
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Debut header cart count ---------- */
  function updateCartCount() {
    return fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        var bubble = document.getElementById('CartCount');
        if (!bubble) {
          var cartLink = document.querySelector('.site-header__cart');
          if (!cartLink) return cart;
          bubble = document.createElement('div');
          bubble.id = 'CartCount';
          bubble.className = 'site-header__cart-count';
          bubble.innerHTML = '<span></span><span class="icon__fallback-text medium-up--hide"></span>';
          cartLink.appendChild(bubble);
        }
        var spans = bubble.querySelectorAll('span');
        if (spans[0]) spans[0].textContent = count;
        if (spans[1]) spans[1].textContent = count + (count === 1 ? ' item' : ' items');
        bubble.classList.toggle('hide', count === 0);
        document.dispatchEvent(new CustomEvent('ma:cart-updated', { detail: cart }));
        return cart;
      })
      .catch(function () {});
  }

  /* ---------- Add to cart ---------- */
  function addToCart(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.classList.contains('is-loading')) return;
    var name = btn.getAttribute('data-product-title') || '';
    var item = { id: Number(id), quantity: 1 };
    var plan = btn.getAttribute('data-selling-plan');
    if (plan) item.selling_plan = Number(plan);
    var cartUrl = root + 'cart';
    var original = btn.innerHTML;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'This item could not be added.');
          return data;
        });
      })
      .then(function () {
        toast('\u2713 Added to cart \u00b7 ' + esc(name) + '<a href="' + cartUrl + '">View cart</a>');
        return updateCartCount();
      })
      .catch(function (err) {
        toast(esc(err.message) + ' <a href="' + cartUrl + '">Go to cart</a>', true);
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.innerHTML = original;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ma-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn);
  });

  /* ---------- Shop-by-goal tabs ---------- */
  function selectTab(tab) {
    var wrap = tab.closest('[data-ma-tabs]');
    if (!wrap) return;
    wrap.querySelectorAll('[role="tab"]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
  }
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-ma-tabs] [role="tab"]');
    if (tab) selectTab(tab);
  });
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-ma-tabs] [role="tab"]');
    if (!tab || ['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(e.key) === -1) return;
    var tabs = Array.prototype.slice.call(tab.parentNode.querySelectorAll('[role="tab"]'));
    var i = tabs.indexOf(tab);
    if (e.key === 'ArrowRight') i = (i + 1) % tabs.length;
    if (e.key === 'ArrowLeft') i = (i - 1 + tabs.length) % tabs.length;
    if (e.key === 'Home') i = 0;
    if (e.key === 'End') i = tabs.length - 1;
    e.preventDefault();
    tabs[i].focus();
    selectTab(tabs[i]);
  });

  /* ---------- Sticky CTA ---------- */
  var ticking = false;
  function updateSticky() {
    ticking = false;
    document.querySelectorAll('[data-ma-sticky]').forEach(function (bar) {
      var offset = parseInt(bar.getAttribute('data-offset'), 10) || 900;
      var nearBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 200;
      var show = window.scrollY > offset && !nearBottom;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(updateSticky); }
  }, { passive: true });

  /* Theme editor: re-run when sections are added/edited, and show the selected goal block. */
  document.addEventListener('shopify:section:load', updateSticky);
  document.addEventListener('shopify:block:select', function (e) {
    var tab = document.querySelector('[data-ma-tabs] [role="tab"][data-block-id="' + e.detail.blockId + '"]');
    if (tab) selectTab(tab);
  });

  updateSticky();
})();
